<template>
	<v-layout row wrap>

		<financial-table-element
			lighten='1'
			xs="11"
			text='Suma kosztów administracyjnych'
		></financial-table-element>

		<financial-table-element
			lighten='1'
			xs="1"
			:text="formatMoney(totalAdministrative)"
		></financial-table-element>

	</v-layout>
</template>
<script>
	import FinancialTableElement from "../FinancialTableRowElement";
	import {Numbers} from "../../../../../utils/Numbers";

	export default {
		name: "sumOfAdministrative",
		components: {FinancialTableElement},
		props: {
			totalAdministrative: {},
		},
		mixins: [Numbers],
	};
</script>

<style scoped>
	.theme--dark .grey.lighten-3 {
		background-color: red !important;
	}
</style>